export type LogBlock =
  | { type: "paragraph"; text: string }
  | { type: "list"; items: string[] }
  | { type: "quote"; text: string };

export interface LogEntry {
  id: string;
  publishedAt: string;
  title?: string;
  tags: string[];
  blocks: LogBlock[];
  source?: {
    title: string;
    author: string;
    location?: string;
    href: string;
  };
}

export const logs: LogEntry[] = [
  {
    id: "matt-pocock-skills",
    publishedAt: "2026-08-13",
    title: "My Agent Skills Workflow",
    tags: ["ai", "workflow"],
    blocks: [
      {
        type: "list",
        items: [
          "For hard-to-reproduce issues, diagnosing-bugs helps narrow down the evidence and hypotheses first.",
          "For module boundaries, codebase-design and domain-modeling help clarify responsibilities and terminology.",
          "During implementation, I use tdd for key behaviors, then code-review to check the result against the requirements and project standards.",
        ],
      },
    ],
    source: {
      title: "mattpocock/skills",
      author: "Matt Pocock",
      href: "https://github.com/mattpocock/skills/tree/main",
    },
  },
  {
    id: "system-design-interview",
    publishedAt: "2023-11-16",
    tags: ["reading"],
    blocks: [
      {
        type: "quote",
        text:
          "The system design questions are open-ended. Just like in the real world, there are many differences and variations in the system.",
      },
    ],
    source: {
      title: "System Design Interview: An Insider's Guide",
      author: "Alex Xu",
      location: "Foreword",
      href: "https://bytebytego.com/courses/system-design-interview/foreword",
    },
  },
  {
    id: "talent",
    publishedAt: "2023-11-16",
    tags: ["reading"],
    blocks: [
      {
        type: "quote",
        text:
          "There is a striking study of violinists and how they excel—namely, through practice. " +
          "But do you know what kind of practice is most predictive of success? No, it is not teacher-designed practice; rather, it is practice alone, driven and directed by oneself. " +
          "Think of practice habits as one path toward continuously compounding learning and performance. " +
          "Try to learn the practice habits of the person you are interviewing, as it will reveal one aspect of their approach to work. " +
          "You also should try to learn just how self-conscious a person is about what he or she is doing for self-improvement.",
      },
    ],
    source: {
      title:
        "Talent: How to Identify Energizers, Creatives, and Winners Around the World",
      author: "Tyler Cowen and Daniel Gross",
      location: "Chapter 2",
      href: "https://us.macmillan.com/books/9781250275813/talent/",
    },
  },
  {
    id: "designing-data-intensive-applications",
    publishedAt: "2022-05-22",
    tags: ["reading"],
    blocks: [
      {
        type: "quote",
        text:
          "Raw CPU power is rarely a limiting factor for these applications—bigger problems are usually the amount of data, the complexity of data…",
      },
    ],
    source: {
      title: "Designing Data-Intensive Applications",
      author: "Martin Kleppmann",
      location: "Chapter 1",
      href:
        "https://www.oreilly.com/library/view/designing-data-intensive-applications/9781491903063/ch01.html",
    },
  },
];
